import { syncAddAccount } from '@/API/repositories/meta';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRef } from 'react';

const useSyncLeadsCostForm = ({ setShow }) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const fromDateRef = useRef();
	const toDateRef = useRef();

	const handleSubmit = async (e, metaAccount) => {
		e.preventDefault();

		const payload = {
			fromDate: fromDateRef.current.value,
			toDate: toDateRef.current.value,
			metaAccount: metaAccount._id,
		};

		const response = await makeRequest(syncAddAccount.bind(null, payload));

		if (response?.data) {
			setShow(() => false);
			return addMessage('Meta Account Sync', 'success');
		}

		addMessage('Something went wrong!', 'error');
	};

	return {
		handleSubmit,
		fromDateRef,
		toDateRef,
		isLoading: hasUnfilledRequest(syncAddAccount),
	};
};

export default useSyncLeadsCostForm;
